var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background",style:({ backgroundImage: `url('${_vm.bgImage}')` })},[_c('div',{staticClass:"wrapper"},[_c('game-component')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }